import React, { useState, useContext } from "react";
import { Field } from "formik";
import { get, isEmpty } from "lodash";
import {
  FieldInputDollar,
  FieldButtonGroup,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldTextarea,
  FieldInputNumber,
  FieldInputPercentage,
  DatePicker,
  MultiSelectDropdown,
  InvestmentTypeDropdown,
  EmployeeClassificationTypeDropdown,
  FieldInputDecimal,
  InvestmentCategoryDropdown,
  FieldMultiSelectButtonGroup,
} from "../../../../../components";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  toMultiSelectValueById,
  clearFieldValues,
} from "../../../../../utils";
import { manageRkaasStore } from "../../../../../contexts";
import { useRequest } from "../../../../../abstracts";
import {
  getCompaniesList,
  getCompetingFunds,
  getApplicableInvestments,
} from "../../../../../services";
import ModelPortfolio from "./ModelPortfolio";

const restrictionLabel = {
  1: "No of days with restriction",
  2: "No of weeks with restriction",
  3: "No of months with restriction",
  4: "No of years with restriction",
};

const BasicDetailsFields = (props) => {
  const { state, dispatch } = useContext(manageRkaasStore);
  const {
    fields,
    values,
    setFieldValue,
    setValues,
    isEdit,
    isSave,
    handleChange,
    setTabGrey,
    investmentId,
    setType,
    initialValues,
    isAdd,
    investmentTypes,
    setInvestmentTypes,
  } = props;
  const { response: companies } = useRequest({
    method: getCompaniesList,
    payload: 1, //TenantId. HardCoding should be removed
    defaultResponse: [],
  });
  const typeOfEarnings = get(values, fields.typeOfEarnings, []);
  const dblList = (min, max) => {
    const listOptions = [];
    obj = {};
    for (var i = min; i <= max; i++) {
      var obj = {};
      obj["id"] = i;
      obj["value"] = i;
      obj["label"] = `${i}`;
      listOptions.push(obj);
    }
    return listOptions;
  };
  const [investmentCategories, setInvestmentCategories] = useState([]);
  const { response: competingFundsList } = useRequest({
    method: getCompetingFunds,
    payload: investmentId != undefined ? investmentId : 0,
    defaultResponse: [],
  });

  const { response: investmentsList } = useRequest({
    method: getApplicableInvestments,
    defaultResponse: [],
  });

  return (
    <>
      <div>
        <Field
          size="smdd"
          name={fields.includeInvestmentIn}
          label={"Include this investment in"}
          isRequired
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.INCLUDE_INVESTMENT_IN
          )}
          selectedValue={values[fields.includeInvestmentIn]}
          value={values[fields.includeInvestmentIn]}
          onChange={(value) => {
            setTabGrey(1);
            setFieldValue(fields.includeInvestmentIn, value);
            setFieldValue(fields.companyId, null);
          }}
          component={FieldButtonGroup}
          disabled={!isAdd}
        />
        {values[fields.includeInvestmentIn] === 2 && (
          <Field
            name={fields.companyId}
            isRequired
            label="Company Name"
            value={values[fields.companyId]}
            disabled={!isAdd}
            options={
              companies &&
              companies.map((company, index) => ({
                label: company.name,
                value: parseInt(company.id),
              }))
            }
            popupContent={
              <SearchableList
                label="Select a Company"
                options={
                  companies &&
                  companies.map((company, index) => ({
                    label: company.name,
                    value: parseInt(company.id),
                  }))
                }
                onSelect={(value) => {
                  setTabGrey(1);
                  setFieldValue(fields.companyId, value);
                }}
                selectedValue={values[fields.companyId]}
                disabled={!isAdd}
              />
            }
            component={FieldDropSide}
          />
        )}

        <Field
          isRequired
          label="Investment Type"
          name={fields.type}
          value={values[fields.type]}
          options={investmentTypes}
          popupContent={
            <InvestmentTypeDropdown
              data={investmentTypes}
              onSelect={(value, name) => {
                setTabGrey(1);
                if (value === 1) {
                  setValues({
                    ...clearFieldValues({
                      values,
                      fieldsToExculde: [
                        fields.includeInvestmentIn,
                        fields.companyId,
                        fields.isReallocationAllowed,
                        fields.isRebalanceAllowed,
                      ],
                    }),
                    [fields.isReallocationAllowed]: true,
                    [fields.isRebalanceAllowed]: true,
                    [fields.excludeSunday]: false,
                    [fields.excludeSaturday]: false,
                  });
                } else {
                  setValues({
                    ...clearFieldValues({
                      values,
                      fieldsToExculde: [
                        fields.includeInvestmentIn,
                        fields.companyId,
                      ],
                    }),
                    ...initialValues,
                  });
                }
                setType(value);
                setFieldValue(fields.type, value);
              }}
              type={!isEdit && !isAdd && values && values[fields.type] !== 1}
              setData={(newData) => setInvestmentTypes(newData)}
              value={values[fields.type]}
            />
          }
          disabled={isEdit || (!isAdd && values && values[fields.type] === 1)}
          component={FieldDropSide}
        />
        {values[fields.type] === 1 ? (
          <ModelPortfolio
            fields={fields}
            isEdit={isEdit}
            isSave={isSave}
            setTabGrey={setTabGrey}
            investmentsList={investmentsList}
            intInvestmentId={investmentId}
            investmentStatusOptions={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
            )}
          />
        ) : (
          <>
            <Field
              isRequired
              label="Investment category"
              name={fields.investmentCategory}
              value={values[fields.investmentCategory]}
              options={investmentCategories}
              popupContent={
                <InvestmentCategoryDropdown
                  data={investmentCategories}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.investmentCategory, value);
                  }}
                  setData={(newData) => setInvestmentCategories(newData)}
                  value={values[fields.investmentCategory]}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
            <Field
              size="smd"
              name={fields.accountType}
              label={"Account Type"}
              isRequired
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.ACCOUNT_TYPE_MASTER
              )}
              selectedValue={values[fields.accountType]}
              value={values[fields.accountType]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.accountType, value);
              }}
              component={FieldButtonGroup}
              disabled={isEdit && !isSave}
            />
            <Field
              name={fields.name}
              label={"Investment Name"}
              isRequired
              selectedValue={values[fields.name]}
              value={values[fields.name]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              component={FieldInput}
              disabled={isEdit && !isSave}
            />
            <Field
              name={fields.description}
              label={"Investment Description"}
              //isRequired
              //placeholder="Placeholder"
              selectedValue={values[fields.description]}
              value={values[fields.description]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              component={FieldTextarea}
              disabled={isEdit && !isSave}
            />
            <Field
              name={fields.status}
              isRequired
              label="Investment Status"
              value={values[fields.status]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
              )}
              popupContent={
                <SearchableList
                  label="Select an investment status"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
                  )}
                  onSelect={(value) => setFieldValue(fields.status, value)}
                  onChange={() => {
                    setTabGrey(1);
                    setFieldValue(fields.suspendedFromDate, null);
                    setFieldValue(fields.suspendedToDate, null);
                    setFieldValue(fields.inceptionDate, null);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
            {values[fields.status] === 4 && (
              <>
                <Field
                  size="smd"
                  name={fields.suspendedFromDate}
                  placeholder="To"
                  value={usDateFormat(values[fields.suspendedFromDate])}
                  direction="right"
                  isDatePicker
                  isRequired
                  label="Suspended From"
                  onClear={() => setFieldValue(fields.suspendedFromDate, "")}
                  popupContent={
                    <DatePicker
                      onDayClick={(value) => {
                        setTabGrey(1);
                        setFieldValue(fields.suspendedFromDate, value);
                      }}
                      value={usDateFormat(values[fields.suspendedFromDate])}
                    />
                  }
                  disabled={isEdit && !isSave}
                  component={FieldDropSide}
                />
                <Field
                  size="smd"
                  name={fields.suspendedToDate}
                  placeholder="To"
                  value={usDateFormat(values[fields.suspendedToDate])}
                  direction="right"
                  isDatePicker
                  onClear={() => setFieldValue(fields.suspendedToDate, "")}
                  label="Suspended to"
                  isRequired
                  popupContent={
                    <DatePicker
                      onDayClick={(value) => {
                        setTabGrey(1);
                        setFieldValue(fields.suspendedToDate, value);
                      }}
                      value={usDateFormat(values[fields.suspendedToDate])}
                    />
                  }
                  disabled={isEdit && !isSave}
                  component={FieldDropSide}
                />
              </>
            )}
            <Field
              size="smd"
              isRequired
              name={fields.inceptionDate}
              label={"Investment Inception Date"}
              value={usDateFormat(values[fields.inceptionDate])}
              isDatePicker
              onClear={() => setFieldValue(fields.inceptionDate, "")}
              popupContent={
                <DatePicker
                  maxDate={new Date()}
                  onDayClick={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.inceptionDate, value);
                  }}
                  value={usDateFormat(values[fields.inceptionDate])}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
              //validate={required}
            />
            <Field
              size="md"
              isRequired
              name={fields.fundCode}
              label={"Fund Code"}
              type="text"
              autoComplete="off"
              value={values[fields.fundCode]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInput}
              // validate={required}
            />
            <Field
              size="md"
              name={fields.fundFamily}
              label={"Fund Family"}
              type="text"
              autoComplete="off"
              maxLength="4"
              preventSpecialCharacter={true}
              value={values[fields.fundFamily]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInput}
              // validate={required}
            />
            <Field
              size="md"
              isRequired
              name={fields.cusip}
              label="CUSIP"
              noLabelTransform={true}
              maxLength="9"
              preventSpecialCharacter={true}
              type="text"
              autoComplete="off"
              value={values[fields.cusip]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInput}
            />
            <Field
              size="md"
              // isRequired
              name={fields.sedol}
              label="SEDOL"
              noLabelTransform={true}
              type="text"
              autoComplete="off"
              maxLength="7"
              preventSpecialCharacter={true}
              value={values[fields.sedol]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInput}
            />
            <Field
              size="md"
              // isRequired
              name={fields.isin}
              label="ISIN"
              noLabelTransform={true}
              type="text"
              autoComplete="off"
              maxLength="12"
              preventSpecialCharacter={true}
              value={values[fields.isin]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInput}
            />
            <Field
              size="smd"
              name={fields.ticker}
              label={"Ticker"}
              type="text"
              autoComplete="off"
              minLength="2"
              value={values[fields.ticker]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInput}
            />
            <Field
              size="smd"
              isRequired
              name={fields.shareClass}
              label={"Share Class"}
              value={values[fields.shareClass]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.INVESTMENT_SHARE_CLASS
              )}
              popupContent={
                <SearchableList
                  label="Select a Share Class"
                  isNotTypeAhead
                  isRadio
                  selectedValue={values[fields.shareClass]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.INVESTMENT_SHARE_CLASS
                  )}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.shareClass, value);
                  }}
                />
              }
              component={FieldDropSide}
            />
            <Field
              size="lg"
              isRequired
              name={fields.typeOfEarnings}
              label={"Type Of Earnings"}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.TYPE_OF_EARNINGS
              )}
              selectedValue={typeOfEarnings}
              value={typeOfEarnings}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.typeOfEarnings, value);
              }}
              component={FieldMultiSelectButtonGroup}
              disabled={isEdit && !isSave}
            />

            <Field
              size="sm"
              isRequired
              name={fields.isInvestmentQDIA}
              label={"Investment is QDIA?"}
              noLabelTransform
              options={yesNoOptions}
              selectedValue={values[fields.isInvestmentQDIA]}
              value={values[fields.isInvestmentQDIA]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.isInvestmentQDIA, value);
              }}
              component={FieldButtonGroup}
              disabled={isEdit && !isSave}
            />
            <Field
              isRequired
              name={fields.volatility}
              label={"Volatility"}
              value={values[fields.volatility]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.INVESTMENT_VOLATILITY
              )}
              popupContent={
                <SearchableList
                  label="Select a Volatility"
                  isNotTypeAhead
                  isRadio
                  selectedValue={values[fields.volatility]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.INVESTMENT_VOLATILITY
                  )}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.volatility, value);
                  }}
                />
              }
              component={FieldDropSide}
              //validate={required}
            />
            <Field
              isRequired
              name={fields.prospectusDeliveryMethod}
              label={"Prospectus Delivery Method"}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.PROSPECTUS_DELIVERY_METHOD
              )}
              selectedValue={values[fields.prospectusDeliveryMethod]}
              value={values[fields.prospectusDeliveryMethod]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.prospectusDeliveryMethod, value);
              }}
              component={FieldMultiSelectButtonGroup}
              disabled={isEdit && !isSave}
            />

            <Field
              size="sm"
              name={fields.isEquityWashRuleApplicable}
              label={"Equity Wash Rule"}
              isRequired
              options={yesNoOptions}
              selectedValue={values[fields.isEquityWashRuleApplicable]}
              value={values[fields.isEquityWashRuleApplicable]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.isEquityWashRuleApplicable, value);
              }}
              component={FieldButtonGroup}
              disabled={isEdit && !isSave}
            />
            {values[fields.isEquityWashRuleApplicable] && (
              <>
                <Field
                  isRequired
                  name={fields.competingFunds}
                  label={"Competing Fund(s)"}
                  isMultiSelect
                  value={toMultiSelectValueById(
                    values[fields.competingFunds],
                    competingFundsList.map((item, index) => ({
                      label: item.investmentName,
                      value: parseInt(item.investmentId),
                    }))
                  )}
                  popupContent={
                    <MultiSelectDropdown
                      label="Competing Fund(s)"
                      name={fields.competingFunds}
                      onSelect={(value) => {
                        setTabGrey(1);
                        setFieldValue(fields.competingFunds, value);
                      }}
                      maxHeight="200px"
                      height="190px"
                      value={values[fields.competingFunds]}
                      options={competingFundsList.map((item, index) => ({
                        label: item.investmentName,
                        value: parseInt(item.investmentId),
                      }))}
                      disabled={isEdit && !isSave}
                      isTypeAhead
                    />
                  }
                  disabled={isEdit && !isSave}
                  component={FieldDropSide}
                />
                <Field
                  isRequired
                  name={fields.restrictedPeriod}
                  label={"Restricted Period"}
                  value={values[fields.restrictedPeriod]}
                  disabled={isEdit && !isSave}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.RESTRICTED_PERIOD
                  )}
                  popupContent={
                    <SearchableList
                      label="Restricted Period"
                      isNotTypeAhead
                      isRadio
                      selectedValue={values[fields.restrictedPeriod]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.RESTRICTED_PERIOD
                      )}
                      onChange={() => {
                        setTabGrey(1);
                        setFieldValue(fields.restrictedPeriodValue, "");
                      }}
                      onSelect={(value) => {
                        setFieldValue(fields.restrictedPeriodValue, "");
                        setFieldValue(fields.restrictedPeriod, value);
                      }}
                    />
                  }
                  component={FieldDropSide}
                />
                <Field
                  size="smd"
                  isRequired
                  name={fields.restrictedPeriodValue}
                  label={restrictionLabel[values[fields.restrictedPeriod]]}
                  type="number"
                  autoComplete="off"
                  value={values[fields.restrictedPeriodValue]}
                  onChange={(e) => {
                    setTabGrey(1);
                    handleChange(e);
                  }}
                  min={1}
                  max={values[fields.restrictedPeriod] == 1 ? 999 : 99}
                  disabled={isEdit && !isSave}
                  component={FieldInputNumber}
                />
              </>
            )}
            {/* Pricing and Income */}
            {/* <Field
              size="smd"
              name={fields.closureDate}
              placeholder="To"
              value={usDateFormat(values[fields.closureDate])}
              direction="right"
              isDatePicker
              isRequired
              label="As of close"
              onClear={() => setFieldValue(fields.closureDate, "")}
              popupContent={
                <DatePicker
                  onDayClick={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.closureDate, value);
                  }}
                  value={usDateFormat(values[fields.closureDate])}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            /> */}
            <Field
              isRequired
              size="smd"
              name={fields.precision}
              label={"Pricing Precision"}
              value={values[fields.precision]}
              disabled={isEdit && !isSave}
              options={dblList(0, 9)}
              popupContent={
                <SearchableList
                  label="Precision"
                  isNotTypeAhead
                  isRadio
                  selectedValue={values[fields.precision]}
                  options={dblList(0, 9)}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.precision, value);
                    setFieldValue(fields.value, "");
                  }}
                />
              }
              component={FieldDropSide}
            />

            <Field
              name={fields.postingRulesForSells}
              isRequired
              label="Posting Rules For Sells"
              value={values[fields.postingRulesForSells]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.POSTING_RULES
              )}
              popupContent={
                <SearchableList
                  label="Select an posting rules for sells"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.POSTING_RULES
                  )}
                  onSelect={(value) =>
                    setFieldValue(fields.postingRulesForSells, value)
                  }
                  selectedValue={values[fields.postingRulesForSells]}
                  onChange={() => {
                    setTabGrey(1);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />

            <Field
              name={fields.postingRulesForBuys}
              isRequired
              label="Posting Rules For Buys"
              value={values[fields.postingRulesForBuys]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.POSTING_RULES
              )}
              popupContent={
                <SearchableList
                  label="Select an posting rules for buys"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.POSTING_RULES
                  )}
                  onSelect={(value) =>
                    setFieldValue(fields.postingRulesForBuys, value)
                  }
                  selectedValue={values[fields.postingRulesForBuys]}
                  onChange={() => {
                    setTabGrey(1);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
          </>
        )}
      </div>
    </>
  );
};

export default BasicDetailsFields;
